import { render } from "./MigrationConsole.vue?vue&type=template&id=35c969b8&scoped=true&ts=true"
import script from "./MigrationConsole.vue?vue&type=script&lang=ts"
export * from "./MigrationConsole.vue?vue&type=script&lang=ts"

import "./MigrationConsole.vue?vue&type=style&index=0&id=35c969b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c969b8"]])

export default __exports__